"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormCopyModal = void 0;
const tslib_1 = require("tslib");
const modal_form_component_1 = require("../../components/modal.form/modal.form.component");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const org_department_selector_1 = require("../org.department.selector/org.department.selector");
const form_copy_modal_style_1 = require("./form.copy.modal.style");
(0, theme_1.addStyles)(form_copy_modal_style_1.Style);
class FormCopyModal extends modal_form_component_1.ModalFormComponent {
    constructor(ctx, form) {
        super(ctx);
        this.targetForm = form;
        this.departmentSelector = new org_department_selector_1.OrgDepartmentSelector({ crossOrganization: true });
        this.addState(this.departmentSelector.inputState);
    }
    get nodes() {
        return (0, mithril_1.m)('div', { className: form_copy_modal_style_1.CSS.container }, [
            (0, mithril_1.m)('div', (0, i18n_1.Translate)(i18n_1.T.FORM_COPY_TO_DEPARTMENT_DESCRIPTION)),
            (0, mithril_1.m)('div', { className: form_copy_modal_style_1.CSS.content }, [
                (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.FORM_COPY_TO_DEPARTMENT_CONFIRM, { name: this.targetForm.displayname })),
                this.departmentSelector.view(),
            ]),
        ]);
    }
    submit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const selectedDepartmentId = this.departmentSelector.selectedDepartmentId;
            if (selectedDepartmentId == null) {
                return null;
            }
            return services_1.Services.Form.copy(this.targetForm.objectId, selectedDepartmentId);
        });
    }
}
exports.FormCopyModal = FormCopyModal;
//# sourceMappingURL=form.copy.modal.js.map